// Globaly defined in variables liv-wishlist-products.liquid:
// show_mobile_slider, show_desktop_slider and animations_reveal_on_scroll

var liElementClasses =
  "grid__item grid__item_featured " +
  (window.show_mobile_slider || window.show_desktop_slider
    ? " slider__slide "
    : " ") +
  (window.animations_reveal_on_scroll
    ? " scroll-trigger animate--slide-in "
    : " ");

var productCards = "";
var storageKey = "liv-wishlist-product-" + window.shopId;
var tempArray = JSON.parse(localStorage.getItem(storageKey)) || [];
var string_to_replace = "";
if (window.money_with_currency_format.includes("{{amount_with_comma_separator}} ")){
  string_to_replace = "{{amount_with_comma_separator}}"
}else {
  string_to_replace = "{{amount}}"
}
  if (tempArray.length < 1){
    var wishlist_empty = document.getElementById("wishlist-empty");
    wishlist_empty.style.display="flex"
  
  }else {
    var liElement = document.getElementById("inject-wishlist");
    
  
for (var i = 0; i < tempArray.length; i++) {
  productCards +=
    `<li id="Slide-` +
    window.section_id +
    `-` +
    i +
    `" class="` +
    liElementClasses +
    `">  
      <div class="card card--standard card--media" style="--ratio-percent: 125%">
      <div
        class="card__inner color-` +
    window.card_color_scheme +
    ` gradient ratio"
        style="--ratio-percent: 125%"
      >
        <div class="card__media">
          <div class="media media--transparent media--hover-effect">
            <img
              src="` +
    tempArray[i].picture_url +
    `"
              alt="` +
    tempArray[i].title +
    `"
              class="motion-reduce"
              loading="lazy"
              style="object-fit: contain; background: white"
            />
          </div>
        </div>
        <div class="card__content">
          <div class="card__information">
            <h3 class="card__heading">
              <a
                href="` +
    tempArray[i].URL +
    `"
                class="full-unstyled-link"
              >
                ` +
    tempArray[i].title +
    `
              </a>
            </h3>
          </div>

          <div class="card__badge bottom left"></div>
        </div>
      </div>
      <div class="card__content">
        <div class="card__information">
          <div class="card-information">
            <span class="visually-hidden">Vendor:</span>
            <div class="caption-with-letter-spacing">
              <h5 class="liv-vendor">` +
    tempArray[i].vendor +
    `</h5>
            </div>
            <span class="caption-large"></span>

            <h3
              class="card__heading h5"
              id="title-` +
    window.section_id +
    `-` +
    tempArray[i].id +
    `"
            >
              <a
                href="` +
    tempArray[i].URL +
    `"
                id="CardLink-` +
    window.section_id +
    `-` +
    tempArray[i].id +
    `"
                class="full-unstyled-link"
                aria-labelledby="CardLink-` +
    window.section_id +
    `-` +
    tempArray[i].id +
    ` Badge-` +
    window.section_id +
    `-` +
    tempArray[i].id +
    `"
              >
              ` +
    tempArray[i].title +
    `
              </a>
            </h3>

            <div class="price">
              <div class="price__container">
                <div class="price__regular">
                  <span class="visually-hidden visually-hidden--inline"
                    >Regular price</span
                  >
                  <span class="price-item price-item--regular">
                    ` +
                    window.money_with_currency_format.replace(string_to_replace, tempArray[i].price / 100) 
                    +`
                  </span>
                </div>
                <small class="unit-price caption hidden">
                  <span class="visually-hidden">Unit price</span>
                  <span class="price-item price-item--last">
                    <span></span>
                    <span aria-hidden="true">/</span>
                    <span class="visually-hidden">&nbsp;per&nbsp;</span>
                    <span> </span>
                  </span>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="card__badge bottom left"></div>
      </div>
    </div>
  </li>
  `;
}

liElement.innerHTML = productCards;
}